import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TreeSelect } from 'antd';
import { Form } from 'react-bootstrap';

export const PrePaymentComponent: React.FC<{
  formik: any;
  onClose: () => void;
  OperatingUnitOptions: any[];
  treeSuppliersData: any[];
}> = ({ formik, onClose, OperatingUnitOptions, treeSuppliersData }) => {
  const { values, setFieldValue } = formik;
  const navigate = useNavigate();

  const handleSubmit = () => {
    // للسلفة، ننشئ قائمة فارغة لأن المبلغ مدخل يدوياً
    formik?.setFieldValue('scheduleList', []);
    onClose();
  };

  const isFormValid = values.amount && values.amount > 0;

  return (
    <div>
      <div className='row g-3 mb-4'>
        <div className='col-lg-5'>
          <div className='form-group'>
            <label className='form-label fw-bold'>المورد</label>
            <TreeSelect
              showSearch
              className='w-100'
              treeLine
              placeholder='اختر المورد'
              allowClear
              treeDefaultExpandAll={false}
              value={values.peopleId}
              onChange={option => {
                formik.setFieldValue('peopleId', option === null ? null : option);
              }}
              treeData={treeSuppliersData}
              treeNodeFilterProp='title'
              getPopupContainer={triggerNode => triggerNode.parentNode}
            />
          </div>
        </div>

        <div className='col-lg-5'>
          <div className='form-group'>
            <label className='form-label fw-bold'>الوحدة التشغيلية</label>
            <Select
              isSearchable={true}
              isClearable
              options={OperatingUnitOptions}
              value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
              onChange={(option: any) => {
                setFieldValue('organizationId', option === null ? null : option.value);
              }}
              placeholder='اختر الوحدة التشغيلية'
              className='react-select-container'
              classNamePrefix='react-select'
            />
          </div>
        </div>

        <div className='col-lg-2'>
          <div className='form-group'>
            <label className='form-label fw-bold'>المبلغ</label>
            <Form.Control
              className='form-control text-center fw-bold border-theme'
              type='text'
              autoComplete='off'
              name='amount'
              onChange={formik.handleChange}
              value={values.amount || ''}
              // onInput={e => {
              //   const input = e.target as HTMLInputElement;
              //   input.value = input.value.replace(/[^0-9]/g, '');
              // }}
              onInput={e => {
                const input = e.target as HTMLInputElement;
                input.value = input.value
                  .replace(/[^0-9.]/g, '') // يسمح بالأرقام و .
                  .replace(/(\..*)\./g, '$1'); // يمنع أكثر من نقطة
              }}
              placeholder='0'
            />
          </div>
        </div>
      </div>

      <div className='alert alert-info d-flex align-items-center mb-4'>
        <i className='fas fa-info-circle me-2 fa-lg'></i>
        <div>
          <h6 className='alert-heading mb-1'>دفع مسبق للمورد</h6>
          <p className='mb-0'>يتم إضافة مبلغ سلفة للمورد دون ربطها بفواتير محددة</p>
        </div>
      </div>

      <div className='border-top mt-4 pt-4'>
        <div className='d-flex justify-content-between align-items-center'>
          <div>
            {/* {isFormValid && (
              <div className='alert alert-success d-flex align-items-center py-2 mb-0' role='alert'>
                <i className='fas fa-check-circle me-2'></i>
                <div>جاهز لإضافة سلفة بمبلغ {values.amount?.toLocaleString()}</div>
              </div>
            )} */}
          </div>

          <div className='d-flex'>
            <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
              <i className='fas fa-check me-2'></i>
              تأكيد السلفة
            </button>

            <button
              type='button'
              className='btn btn-outline-secondary'
              onClick={() => navigate('/AP/ApPayments', { replace: true })}
            >
              <i className='fas fa-times me-2'></i>
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
